import * as React from "react";
import { SVGProps } from "react";

const Polybius = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 104" {...props}>
    <path fill="#069dd8" d="M60.7 0h34.7v34.7H60.7zm0 69.5h34.7v34.7H60.7z" />
    <path fill="#1f7995" d="M95.5 34.7h34.7v34.7H95.5z" />
    <path
      fill="#a4be39"
      d="M.004 52.136 24.541 27.6l24.537 24.536L24.54 76.673z"
    />
  </svg>
);

export default Polybius;
